import { getArtist } from "api/artist/artist";

export const queryArtist = ({ slug, user }) => ({
	queryKey: ["artist", slug, user?.uid],
	queryFn: async () => getArtist({ authToken: user?.accessToken, slug }),
});
